<ng-container *ngIf="productGrade">
    <ins-animated-hand
        type="sign"
        size="medium"
        device="desktop"
        [averageScore]="productGrade.gemiddelde_score.score">
    </ins-animated-hand>
</ng-container>
